import { FormAutocompleteOption } from 'app/shared/components/form/Autocomplete';

import { FieldType } from 'constants/formGenerator';

import { FORM_GENERATION_FIELD_NAME } from './LoanFormGenerationForm.constants';

export const getLoanFormIdField = loanFormOptions => ({
  groups: [
    {
      type: FieldType.GROUP,
      title: {},
      fields: [
        {
          type: FieldType.SELECT,
          nameInModel: FORM_GENERATION_FIELD_NAME.FORM_ID,
          inputProps: {
            disablePortal: false,
            OptionContent: FormAutocompleteOption,
            optionKey: 'value',
            placeholder: 'Choose Loan Form',
            label: 'Form',
            required: true,
            variant: 'outlined',
            // Full-span (4-col grid) so long form names aren't truncated.
            columns: 4,
            options: loanFormOptions,
          },
        },
      ],
    },
  ],
});

export const getBorrowerField = borrowerOptions => ({
  groups: [
    {
      type: FieldType.GROUP,
      title: {},
      fields: [
        {
          type: FieldType.SELECT,
          nameInModel: FORM_GENERATION_FIELD_NAME.BORROWER_ID,
          inputProps: {
            disablePortal: false,
            OptionContent: FormAutocompleteOption,
            optionKey: 'value',
            placeholder: 'Choose Borrower',
            label: 'Borrower',
            required: false,
            variant: 'outlined',
            // Full-span (4-col grid) so borrower names aren't truncated.
            columns: 4,
            options: borrowerOptions,
          },
        },
      ],
    },
  ],
});
